import { BundledProduct, ProductBundleState } from 'src/store/productBundle/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setProductBundleSelectedProductsReducer = (state: ProductBundleState, action: PayloadAction<BundledProduct[]>) => {
  state.selectedProducts = Array.isArray(action.payload) ? action.payload : [];
};

export default setProductBundleSelectedProductsReducer;
